import { environment } from 'src/environments/environment';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import {  NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink]
})
export class ErrorPageComponent implements OnInit, OnDestroy {
  logo: string;
  homeImage: any;
  @Input() errorResult;

  skinName = environment.skinName;
  constructor(public settingsService: SettingsService,
    public configService: ConfigurationService) { }

  ngOnInit(): void {
    this.settingsService.showHeader = false;
    this.logo = this.settingsService.logo;
    this.homeImage = this.settingsService.homeImage;
  }

  ngOnDestroy() {
    this.settingsService.showHeader = true;
  }

}
